"use client"

import { Separator as SeparatorPrimitive } from "@base-ui/react/separator"

import { cn } from "../lib/utils"

function Separator({
  className,
  orientation = "horizontal",
  ...props
}: SeparatorPrimitive.Props) {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      data-orientation={orientation}
      orientation={orientation}
      className={cn(
        // `bg-foreground/15` adapts cleanly across modes — dark hairline
        // on light surfaces, light hairline on dark surfaces — without
        // depending on whether the consumer has wired `--border` into
        // its `@theme` block (some BrandKit overrides leave `--border`
        // at a poor-contrast value).
        "shrink-0 bg-foreground/15",
        // base-ui's Separator emits `aria-orientation` only — not the
        // `data-horizontal` / `data-vertical` attributes the previous
        // selectors looked for. Without those, nothing applied dimensions
        // and the element rendered 0×0. Use the JS prop directly so size
        // is guaranteed regardless of which primitive ships underneath.
        orientation === "horizontal" ? "h-px w-full" : "w-px self-stretch",
        className
      )}
      {...props}
    />
  )
}

export { Separator }
